import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MembershipHero from './components/MembershipHero';
import MembershipBenefits from './components/MembershipBenefits';
import WhyJoin from './components/WhyJoin';
import MembershipTiers from './components/MembershipTiers';
import MembershipFAQ from './components/MembershipFAQ';
import FoundingMemberBanner from './components/FoundingMemberBanner';
import KeepExploring from '../../components/feature/KeepExploring';
import SEO from '../../components/feature/SEO';

export default function MembershipPage() {
  const facebookUrl = 'https://www.facebook.com/groups/themommymingle';
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="TMM Membership — Insider & VIP | The Mommy Mingle Gwinnett"
        description="Two tiers. No confusion. TMM Insider is free forever. TMM VIP unlocks early event access, VIP-only events, and partner discounts from $12/month. Built for Gwinnett moms."
        keywords="mom membership Gwinnett County, TMM VIP membership, Mommy Mingle membership, priority event access moms Georgia"
        canonical="/membership"
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'TMM Membership — Insider & VIP | The Mommy Mingle',
            description:
              'Two-tier membership for Gwinnett moms. Free Insider and VIP paid tier with early event access, VIP-only events, and partner discounts.',
            url: `${siteUrl}/membership`,
            publisher: {
              '@type': 'Organization',
              name: 'The Mommy Mingle',
              url: siteUrl,
            },
          },
        ]}
      />
      <Navbar />

      {/* 1. Hero — conversion hook */}
      <MembershipHero facebookUrl={facebookUrl} />

      {/* 2. Tiers — the money section */}
      <MembershipTiers facebookUrl={facebookUrl} />

      {/* 3. VIP Value Stack — 5 reasons */}
      <MembershipBenefits />

      {/* 4. Founding 50 — urgency */}
      <FoundingMemberBanner facebookUrl={facebookUrl} />

      {/* 5. The Real Pitch — social proof + "already coming to events" */}
      <WhyJoin facebookUrl={facebookUrl} />

      {/* 6. FAQ */}
      <MembershipFAQ />

      <KeepExploring
        title="Ready to Explore More?"
        subtitle="The community is already here. Events, guides, resources — all waiting for you."
        items={[
          { label: 'Explore Events', icon: 'ri-calendar-event-line', to: '/events' },
          { label: 'Camp Guide', icon: 'ri-sun-line', href: 'https://gwinnettcampguide.com' },
          { label: 'Join The Mommy Mingle', icon: 'ri-group-line', href: facebookUrl, primary: true },
        ]}
      />
      <Footer />
    </div>
  );
}
